class HelpChatEntry extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('[data-help-details]');
    this.toggle = this.querySelector('[data-help-toggle]');
    this.panel = this.querySelector('[data-help-panel]');
    if (!this.details || !this.toggle) return;

    this.onDocumentKeydown = (event) => {
      if (event.key === 'Escape' && this.details.open) {
        this.details.open = false;
        this.toggle.focus({ preventScroll: true });
      }
    };

    this.details.addEventListener('toggle', () => {
      this.toggle.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
      if (this.details.open && this.panel) {
        const focusTarget = this.panel.querySelector('a, button') || this.panel.querySelector('h2');
        focusTarget?.focus({ preventScroll: true });
      }
    });

    document.addEventListener('keydown', this.onDocumentKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onDocumentKeydown);
  }
}

customElements.define('help-chat-entry', HelpChatEntry);
